import { render, staticRenderFns } from "./SectionRowLink.vue?vue&type=template&id=62c0bc5e&"
import script from "./SectionRowLink.vue?vue&type=script&lang=ts&"
export * from "./SectionRowLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports